const getMembershipLevelName = (membershipLevel: string) => {
  if (membershipLevel === 'rec') {
    return 'REC (Free)';
  } else if (membershipLevel === 'pro_month') {
    return 'Monthly Membership';
  } else if (membershipLevel === 'pro_year') {
    return '12 Month Membership';
  } else if (membershipLevel === 'pro_24month') {
    return '24 Month Membership';
  } else {
    return membershipLevel
      .toUpperCase()
      .replace('_MONTH', ' MONTHLY')
      .replace('_YEAR', ' 12 MONTH')
      .replace('_24MONTH', ' 24 MONTH');
  }
};

export {getMembershipLevelName};
